import { SortResultsPayload } from '~/core/state/actions';
import { State } from '../types/state';

const sortResults = (state: State, payload: SortResultsPayload): State => {
    return {
        ...state,
        controls: state.controls.map((querySet) => {
            if (querySet.querySet.identifier !== payload.querySetIdentifier) {
                return querySet;
            }
            return {
                ...querySet,
                sorting: payload.selectedSort,
            };
        }),
    };
};

export default sortResults;
